<template>
  <article class="m-card-element m-card-element-design-2 m-card-primary m-card-transition">

    <div class="m-card-element-info-data">
      <img
        v-if="satelite.imagen"
        :alt="satelite.titulo"
        :src="satelite.imagen"
      >
      <img
        v-else
        :alt="satelite.titulo"
        src="@/assets/img/ds2.png"
      >

      <h5>
        {{ $t(`mEditionProductSatellitesIncluded.card.type.${tipo}`) }}
      </h5>

      <h2 class="m-card-element-design-2-name">
        {{ satelite.titulo }}
      </h2>
    </div>

    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="satelite.activo"
          class="text-color-success"
        >
          {{ $t('mEditionProductSatellitesIncluded.card.activo') }}
        </h3>
        <h3
          v-else
          class="text-color-black-35"
        >
          {{ $t('mEditionProductSatellitesIncluded.card.inactivo') }}
        </h3>
      </div>

      <span
        v-if="!isRequestLoading"
        key="notLoading"
      >
        <span :class="[isIncluded ? 'text-color-success' : 'text-color-danger', 'margin-left-auto', 'font-size-small']">
          <i :class="[isIncluded ? 'fas fa-check' : 'fas fa-ban', 'font-size-small']"></i>
          {{ isIncluded
            ? $t('mEditionProductSatellitesIncluded.card.included')
            : $t('mEditionProductSatellitesIncluded.card.notIncluded')
          }}
        </span>
      </span>
      <span
        v-else
        key="loading"
      >
        <span :class="[isIncluded ? 'text-color-danger' : 'text-color-success', 'margin-left-auto', 'font-size-small']">
          <i class="fas fa-spinner fa-spin font-size-small"></i>
        </span>
      </span>
    </div>

  </article>
</template>

<script>
export default {
  name: 'MoleculeEditionProductSatellitesIncludedCard',

  props: {
    isIncluded: Boolean,
    isRequestLoading: Boolean,
    satelite: Object,
    // La clave del satelite en el API: decide la etiqueta de la tarjeta
    tipo: {
      type: String,
      default: 'juedroop'
    }
  }
}
</script>
